import React from 'react';
import { App } from 'antd';
import ErrorDescription from 'components/ErrorDescription';

const useDSSNotification = () => {
  const { notification } = App.useApp();
  const notifyError = notification.error;
  const notifySuccess = notification.success;
  const notifyWarning = notification.warning;

  const showError = (error: any, message: string) => {
    if (!error) {
      return;
    }
    notification.error({
      duration: 10,
      message: message,
      description: <ErrorDescription error={error} />,
    });
  };

  return {
    notifyError,
    notifySuccess,
    notifyWarning,
    showError,
  };
};

export default useDSSNotification;
